import React, { useEffect, useState } from 'react';
import { legalApi } from '@/services/api';
import { Breadcrumbs } from '@/components/shared/Breadcrumbs';
import { SeoMeta } from '@/components/seo/SeoMeta';
import { renderMarkdown, PageLoading } from './shared';

const META = {
  consumer: {
    title: 'Användarvillkor för kunder',
    description:
      'Gällande användarvillkor när du skapar konto och använder ByggFynd som konsument. Läs fullständigt dokument innan du godkänner vid registrering.',
    canonicalPath: '/anvandarvillkor-kund',
    breadcrumb: 'Användarvillkor för kunder',
  },
  store: {
    title: 'Användarvillkor för butiker',
    description:
      'Gällande användarvillkor när du registrerar bygghandel på ByggFynd. Läs fullständigt dokument innan du godkänner vid registrering.',
    canonicalPath: '/anvandarvillkor-butik',
    breadcrumb: 'Användarvillkor för butiker',
  },
};

export const AnvandarvillkorRegistrationPage = ({ variant }) => {
  const config = META[variant] || META.consumer;
  const [body, setBody] = useState('');
  const [updatedAt, setUpdatedAt] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    legalApi
      .getTerms()
      .then((res) => {
        if (cancelled) return;
        if (variant === 'store') {
          setBody(res.data?.store_terms || '');
          setUpdatedAt(res.data?.store_terms_updated_at || '');
        } else {
          setBody(res.data?.consumer_terms || '');
          setUpdatedAt(res.data?.consumer_terms_updated_at || '');
        }
        setError(false);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [variant]);

  if (loading) return <PageLoading />;

  return (
    <div className="bg-[#F8FAFC] min-h-screen" data-testid={`anvandarvillkor-${variant}`}>
      <SeoMeta title={config.title} description={config.description} canonicalPath={config.canonicalPath} />
      <div className="container-main py-8">
        <Breadcrumbs items={[{ label: config.breadcrumb }]} />

        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-black text-[#0F172A] mb-2">{config.title}</h1>
          <p className="text-sm text-gray-600 mb-2">
            Genom att kryssa i vid registrering bekräftar du att du tagit del av denna text i sitt fullständiga utförande.
          </p>
          {updatedAt ? <p className="text-sm text-gray-500 mb-8">Senast uppdaterad: {updatedAt}</p> : null}

          <div className="bg-white rounded-md shadow-sm p-8">
            {error ? (
              <p className="text-amber-800">Kunde inte ladda villkoren. Försök igen senare.</p>
            ) : (
              <div className="prose max-w-none">
                {body ? renderMarkdown(body) : <p className="text-gray-500">Inget innehåll är publicerat ännu. Administratören kan lägga in text under Admin → Användarvillkor.</p>}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
